import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { ChooseIconComponent } from 'vhobjects-service';
import { ChooseIconComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService } from 'vhobjects-service/src/services';
@Component({
  selector: 'atw-button-config-quantity',
  templateUrl: './button-config-quantity.component.html',
  styleUrls: ['./button-config-quantity.component.scss'],
})
export class AtwButtonQuantityConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;
  fields_style_border: string = ''; // biến này lưu title của các options border để xác định đang chọn trường nào: {minus,plus,input}
  fields_style_color: string = ''; // biến này lưu title của các options color để xác định đang chọn trường nào: {minus,plus,input}
  fields_style_icon: string = ''; // biến này lưu title của các options icon để xác định đang chọn trường nào: {minus,plus,input}
  fields_style_basic: string = ''; // biến này lưu title của các options basic để xác định đang chọn trường nào: {minus,plus,input}
  dataNameColor: string = ''; // biến này lưu data name của các options color để xác định đang chọn trường nào: {minus,plus,input}
  dataNameBorder: string = ''; // biến này lưu data name của các options border và border-radius để xác định đang chọn trường nào: {minus,plus,input}
  dataNameBorderRadius: string = ''; // biến này lưu data name của các options border và border-radius để xác định đang chọn trường nào: {minus,plus,input}
  isOpenOptionsBorder: boolean = false;
  currentViewAll: any = {};
  dataAfterChange: any = {};
  isViewAll: boolean = false;
  backgroundColor: any = [];
  fonts = []
  //Mảng chứa kiểu viền
  dataBorder = [
    {
      name: 'solid',
      img_border:
        'https://static.thenounproject.com/png/2264019-200.png'
    },
    {
      name: 'dashed',
      img_border:
        'https://static.thenounproject.com/png/2264023-200.png'
    },
    {
      name: 'dotted',
      img_border:
        'https://static.thenounproject.com/png/2449182-200.png'
    },
  ];

  /**
   * Mảng chứa tên các nút
   */
  configStyleBasic = [
    {
      title: 'nut_tang_giam'
    },
    {
      title: 'o_so_luong'
    }
  ]
  /**
   * Mảng chứa tên các nút cho Icon
   */
  configStyleIcon = [
    {
      title: 'nut_giam'
    },
    {
      title: 'nut_tang'
    }
  ]
  /**
   * Mảng chứa tùy chỉnh riêng của object
   */
  fieldsConfig = [
    {
      index: 1,
      title: 'tuy_chinh_thong_so_co_ban'
    },
    {
      index: 2,
      title: 'tuy_chinh_kieu_vien',
    },
    {
      index: 3,
      title: 'tuy_chinh_mau_sac'
    },
    {
      index: 4,
      title: 'tuy_chinh_bieu_tuong'
    },
    {
      index: 5,
      title: 'tuy_chinh_bo_tron'
    },
    {
      index: 6,
      title: 'tuy_chinh_bo_tron_chung'
    }
  ];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'mac_dinh',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'tu_trai_sang_phai',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'tu_phai_sang_trai',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) { }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([background_colors,fonts]: any) => {
      this.backgroundColor = background_colors;
      this.fonts = fonts;
    })
  }
  ngOnChanges() {
    if (!this.staticdata?.accessibility) {
      this.staticdata ??= {}; 
      this.staticdata.accessibility = {}; 
    }
  }
  /**
   * Hàm update staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool: any) => {
      })
  }
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
      })
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
      })
  }
  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
      })
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  openBgColor() {
    if (isPlatformBrowser(this.platformId))
    document.getElementById('input-color').click();
  }
  // chọn item để xử lý thông số cơ bản
  chooseBasic(basic) {
    this.fields_style_basic = basic.title;
    this.openViewAll(this.fieldsConfig[0]);
  }
  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**Hàm này dùng để click chọn màu nền của danh sách màu của ô input.
  * @param bgColor : trả về màu được chọn
  * @param event : trả về element được active
  */
  chooseBgInput(bgColor, event) {
    if (isPlatformBrowser(this.platformId)){
    var activeGradient = document.querySelector(
      '.container-color .active'
    ) as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    const data_background = this.class['btn-quantity__input'];
    data_background['background-color'] = bgColor.bgColor;
    this.updateClass();}
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu của ô tăng giảm số lượng.
  * @param bgColor : trả về màu được chọn
  * @param event : trả về element được active
  */
  chooseBg(bgColor, event) {
    if (isPlatformBrowser(this.platformId)){
    var activeGradient = document.querySelector(
      '.container-color .active'
    ) as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    const data_background = this.class['btn-quantity__amount'];
    data_background['background-color'] = bgColor.bgColor;
    this.updateObject();}
  }


  /**
   *
   * @param icon chọn icon
   */
  chooseIcon(icon) {
    this.fields_style_icon = icon.title;
    this.openViewAll(this.fieldsConfig[3]);
  }
  /**
   *
   * @param style chọn item xử lý border
   */
  chooseBorder(style) {
    this.fields_style_border = style.title;
    this.dataNameBorder = style.data;
    this.openViewAll(this.fieldsConfig[1]);
  }
  /**
   *
   * @param style chọn item xử lý border
   */
  chooseBorderRadius(style) {
    this.fields_style_border = style.title;
    this.dataNameBorderRadius = style.data;
    this.openViewAll(this.fieldsConfig[4]);
  }
  /**
   *
   * @param style chọn item xử lý màu sắc
   */
  chooseColor(style) {
    this.fields_style_color = style.title;
    this.dataNameColor = style.data;
    this.openViewAll(this.fieldsConfig[2]);
  }
  /**
   *  mở bảng chọn biểu tượng
   */

  openDialogChooseIcon() {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      // if (result) {
      //   if (this.fields_style_icon == 'nut_tang giảm') {
      //     this.config.icon.icon_plus = result.icon;
      //     this.config.icon.icon_minus = result.icon;
      //     this.config.icon.type = result.type;
      //     this.updateConfig()
      //   }
      // }
      if (result) {
        if (this.fields_style_icon == 'nut_tang') {
          this.config.icon.icon_plus = result.icon;
          this.config.icon.type = result.type;
          this.updateConfig();
        }
        else if (this.fields_style_icon == 'nut_giam') {
          this.config.icon.icon_minus = result.icon;
          this.config.icon.type = result.type;
          this.updateConfig();
        }
      }
    })
  }
 
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['btn-quantity']['width'] = event.width + 'px';
    if(event.height) this.class['btn-quantity']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value, object: string) {
    if (/\#/.test(value)) {
      const gradient = this.config[`btn-quantity__${object}-gradient`];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb(object);
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index, object: string) {
    const gradient = this.config[`btn-quantity__${object}-gradient`];
    if (gradient['gradient_arr'].length > 1) {
      gradient['gradient_arr'].splice(index, 1);
      this.updateBackgroundRgb(object);
    }
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb(object: string) {
    const gradient = this.config[`btn-quantity__${object}-gradient`];
    const classGradient = this.class[`btn-quantity__${object}`];
    if (gradient.gradient_check) {
      classGradient['background-image'] = "linear-gradient(" + gradient['gradient_direction'] + gradient['gradient_arr'] + ")";
    }
    else {
      classGradient['background-image'] = "none";
    }
    this.updateObject();
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event, object: string) {
    if (isPlatformBrowser(this.platformId)) {
      const gradient = this.config[`btn-quantity__${object}-gradient`];
      const classGradient = this.class[`btn-quantity__${object}`];
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      gradient.gradient_type = direction.type;
      gradient.gradient_direction = direction.direction;
      classGradient['background-image'] = gradient.gradient_type + '(' + gradient.gradient_direction + gradient.gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }
}
